import { render, staticRenderFns } from "./TaskTypePage.vue?vue&type=template&id=2b43a8ae&"
import script from "./TaskTypePage.vue?vue&type=script&lang=ts&"
export * from "./TaskTypePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports